import { createFileRoute } from '@tanstack/react-router';
import CatalogViewPage from '@features/catalog/CatalogViewPage.tsx';
import { z } from 'zod';
import { useCreateCatalogViewStore } from '@features/catalog/useCatalogView.ts';
import { CatalogFilters, useCatalogInfiniteScroll } from '@features/catalog/useCatalogInfiniteScroll.ts';
import { arrayEqual, isNullOrUndefined } from '@utils/utils.tsx';

const filtersEqual = (a: CatalogFilters, b: CatalogFilters): boolean => {
  return a.sort === b.sort && a.priceFilter === b.priceFilter && a.isGuaranteed === b.isGuaranteed;
};

const catalogSearchSchema = z.object({
  selectedSupplierIds: z.array(z.coerce.number()).optional(),
  supplierFilterLevel: z.coerce.number().optional(),
  sort: z.enum(['relevance', 'name-asc', 'name-desc', 'price-asc', 'price-desc']).optional(),
  priceFilter: z.enum(['standard', 'alternative', 'sales', 'delivery']).optional(),
  isGuaranteed: z.coerce.boolean().optional(),
});

const width = window.innerWidth;

export const Route = createFileRoute('/c/$orgId/$portalId/catalog/$categoryEcid')({
  validateSearch: search => catalogSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    console.log('CategoryEcid: beforeLoad', ctx.search, width);
    const categoryEcid = ctx.params.categoryEcid;
    const isCatalogView = categoryEcid ? categoryEcid.split('-').length < 3 : true;
    const filters: CatalogFilters = {
      sort: ctx.search.sort,
      priceFilter: ctx.search.priceFilter,
      isGuaranteed: ctx.search.isGuaranteed,
    };
    if (isNullOrUndefined(ctx.search.productId)) {
      if (isCatalogView) {
        if (
          ctx.cause === 'stay' &&
          useCreateCatalogViewStore.getState().categoryEcid === categoryEcid &&
          arrayEqual(useCreateCatalogViewStore.getState().supplierIds, ctx.search.selectedSupplierIds)
        ) {
          console.log('Zadna zmena');
          return;
        }
        useCreateCatalogViewStore.getState().initializeCatalog(categoryEcid, ctx.search.selectedSupplierIds, ctx.search.supplierFilterLevel);
      } else {
        const currentState = useCatalogInfiniteScroll.getState();
        if (
          ctx.cause === 'stay' &&
          currentState.categoryEcid === categoryEcid &&
          arrayEqual(currentState.supplierIds, ctx.search.selectedSupplierIds) &&
          filtersEqual(currentState.filters, filters)
        ) {
          console.log('Zadna zmena');
          return;
        }
        useCatalogInfiniteScroll.getState().initializeCatalog(categoryEcid, ctx.search.selectedSupplierIds, ctx.search.supplierFilterLevel, filters);
      }
    }
  },
  onEnter: ctx => {
    console.log('onEnter', ctx.search);
  },
});

function RouteComponent() {
  const { selectedSupplierIds, supplierFilterLevel } = Route.useSearch();
  const { categoryEcid } = Route.useParams();

  return <CatalogViewPage categoryEcid={categoryEcid} selectedSupplierIds={selectedSupplierIds} supplierFilterLevel={supplierFilterLevel} />;
}
